<template>
  <a-modal
    ref="model"
    centered
    title="会员消费"
    v-model="visible"
    width="70%"
    okText="确认"
    :footer="null"
    @cancel="onCancel"
    :confirmLoading="confirmLoading"
    :maskClosable="false"
    :destroyOnClose="true"
    :bodyStyle="{ paddingTop: 0 }"
  >
    <div class="content">
      <a-card title="基本信息" :bordered="true" style="margin-top:24px">
        <dataForm
          :colnum="2"
          :data="baseData"
          :content="baseContent"
          :labelCol="8"
          :wrapperCol="16"
          ref="baseForm"
          :showButton="false"
        >
        </dataForm>
      </a-card>
      <a-card
        title="会员信息"
        :bordered="true"
        style="margin-top:24px;margin-bottom:24px"
      >
        <dataForm
          :colnum="2"
          :data="memberData"
          :content="memberContent"
          :labelCol="8"
          :wrapperCol="16"
          ref="memberForm"
          :showButton="false"
        >
        </dataForm>
      </a-card>
    </div>
    <div class="form-action">
      <a-button type="primary" @click="onSubmit" :loading="confirmLoading"
        >确认</a-button
      >
      <a-button @click="onCancel">取消</a-button>
    </div>
  </a-modal>
</template>
<script>
import { cache } from "@/utils/common.js";
import dataForm from "@/components/dataForm/DataForm";
import moment from "moment";
import { accAdd } from "@/utils/common";
moment.locale("zh-cn");
export default {
  name: "MemberCharge",
  components: {
    dataForm
  },
  data() {
    return {
      id: 0,
      confirmLoading: false,
      visible: false,
      baseContent: [],
      memberContent: [],
      baseData: {},
      memberData: {},
      //充值方案
      MemberRechargePlan: null,
      user: null,
      url: {}
    };
  },
  created() {
    this.user = cache.get("user");
    var url = {
      MemberInfoGetDetail: "MemberInfoGetDetail",
      MemberPointAdd: "MemberPointAdd"
    };
    if (this.user.IsGroupSystem) {
      for (let i in url) {
        url[i] = "Group" + url[i];
      }
    }
    this.url = url;
  },
  mounted() {},
  methods: {
    init() {
      let _this = this;
      //基本信息
      this.baseContent = [
        {
          label: "手动积分",
          type: "number",
          name: "Amount",
          min: 0,
          props: {
            message: "请输入兑换积分",
            precision: 2
          },
          option: {
            rules: [{ required: true, message: "请输入兑换积分" }]
          },
          onChange: value => {
            let data = _this.$refs.baseForm.getData();
            data.PointPresent = value;
            _this.pointBalanceChange(data);
          }
        },
        {
          label: "备注",
          placeholder: "请输入备注",
          name: "Remark",
          type: "textarea",
          colnum: 2,
          labelCol: 4,
          wrapperCol: 20,
          props: {
            rows: 2
          }
        }
      ];
      this.memberContent = [
        {
          label: "卡号",
          placeholder: "请输入卡号",
          name: "CardNo",
          props: {
            disabled: true
          }
        },
        {
          label: "姓名",
          placeholder: "请输入姓名",
          name: "Name",
          props: {
            disabled: true
          }
        },
        {
          label: "当前余额",
          type: "number",
          name: "Balance",
          props: {
            disabled: true,
            precision: 2
          }
        },
        {
          label: "消费后余额",
          type: "number",
          name: "afterBalance",
          props: {
            disabled: true,
            precision: 2
          }
        },
        {
          label: "当前积分",
          type: "number",
          name: "PointBalance",
          props: {
            disabled: true,
            precision: 2
          }
        },
        {
          label: "充值后积分",
          type: "number",
          name: "afterPointBalance",
          props: {
            disabled: true,
            precision: 2
          }
        }
      ];
    },
    dataInit() {
      this.baseData = {
        PointPresent: 0
      };
    },
    show(id = 0) {
      this.id = id;
      this.init();
      this.visible = true;
      this.dataInit();
      this.$post(this.url.MemberInfoGetDetail, {
        Id: id
      }).then(res => {
        let data = res.Data;
        let MemberRechargePlan = data.MemberRechargePlan;
        data.afterBalance = data.Balance;
        data.afterPointBalance = data.PointBalance;
        this.memberData = data;
        this.MemberRechargePlan = MemberRechargePlan;
        this.$refs.memberForm.updateData();
      });
    },
    pointBalanceChange(data) {
      this.memberData.PointBalance = this.memberData.PointBalance
        ? this.memberData.PointBalance
        : 0;
      data.PointPresent = data.PointPresent ? data.PointPresent : 0;
      this.$refs.memberForm.form.setFieldsValue({
        afterPointBalance: accAdd(
          this.memberData.PointBalance,
          data.PointPresent
        )
      });
    },
    onSubmit() {
      this.$refs.baseForm.getData(true).then(formData => {
        this.confirmLoading = true;
        this.$post(this.url.MemberPointAdd, {
          MemberCardId: this.memberData.Id,
          Amount: formData.Amount,
          Remark: formData.Remark,
          IsManualPoint: true
        })
          .then(() => {
            this.$message.success("操作成功");
            this.visible = false;
            this.confirmLoading = false;
            this.$emit("submit");
          })
          .catch(() => {});
      });
    },
    onCancel() {
      this.visible = false;
    }
  }
};
</script>

<style lang="less" scoped>
.form-action {
  text-align: center;
  .ant-btn {
    margin-right: 10px;
  }
}

.content {
  min-height: 550px;
}

/deep/.ant-modal-body {
  padding: 0;
}
</style>
